import { shouldRenderMobileApp } from 'utils/detect-environment';
import { useMobileFilterDescription } from './use-mobile-filter-description';
import { useDesktopFilterDescription } from './use-desktop-filter-description';

export const useGetFilterDescription = () => {
    const desktopFilterDescription = useDesktopFilterDescription();
    const mobileFilterDescription = useMobileFilterDescription();
    return shouldRenderMobileApp() ? mobileFilterDescription : desktopFilterDescription;
};
